"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var CardRowButtonSet_1 = require("../../../../../../../../shared/components/editors/CardRowButtonSet");
var notificationHelper_1 = require("../../../../../../../../shared/helpers/notificationHelper");
var CardRowSelectEditor_1 = require("../../../../../../../../shared/components/editors/CardRowSelectEditor");
var CardEditorContainer_1 = require("../../../../../../../../shared/components/containers/CardEditorContainer");
var BrandAffilateEditor = /** @class */ (function (_super) {
    __extends(BrandAffilateEditor, _super);
    function BrandAffilateEditor(props) {
        var _this = _super.call(this, props) || this;
        _this.SID_4BSPP = -1;
        _this.SID_4BSUP = -1;
        _this.SID_4BSPO = -1;
        return _this;
    }
    BrandAffilateEditor.prototype.componentWillMount = function () {
        var _this = this;
        if (this.props.record) {
            var _item = this.props.data.getById(this.props.record.key);
            if (_item) {
                this.setState({
                    pprogram_id: _item.pprogram_id,
                    pprogram_title: _item.pprogram_title,
                    pprograms_avail: [],
                    currency_id: _item.app_currency_id,
                    currency_iso: _item.app_currency_iso,
                    partner_id: _item.usr_partner_id,
                    partner_login: _item.usr_partner_login,
                    partners_avail: [],
                    offer_id: _item.offer_id,
                    offer_title: _item.offer_title,
                    offers_avail: []
                });
            }
        }
        else {
            this.setState({
                pprogram_id: 0,
                pprogram_title: "",
                pprograms_avail: [],
                currency_id: 0,
                currency_iso: "",
                partner_id: 0,
                partner_login: "",
                partners_avail: [],
                offer_id: 0,
                offer_title: "",
                offers_avail: []
            });
        }
        this.SID_4BSPP = this.props.listForBrandStatPProgramsAvail.Subscribe("*", function (id, data) {
            _this.setState({ pprograms_avail: data.data });
        });
        this.SID_4BSUP = this.props.listForBrandStatPartnersAvail.Subscribe("*", function (id, data) {
            _this.setState({ partners_avail: data.data });
        });
        this.SID_4BSPO = this.props.listForBrandStatPartnerOffersAvail.Subscribe("*", function (id, data) {
            _this.setState({ offers_avail: data.data });
        });
        this.props.listForBrandStatPProgramsAvail.LoadData(this.props.rootRecord.key);
        this.doReSetRules();
    };
    BrandAffilateEditor.prototype.componentWillUnmount = function () {
        if (this.SID_4BSUP >= 0) {
            this.props.listForBrandStatPartnersAvail.UnSubscribe(this.SID_4BSUP);
        }
        if (this.SID_4BSPP >= 0) {
            this.props.listForBrandStatPProgramsAvail.UnSubscribe(this.SID_4BSPP);
        }
        if (this.SID_4BSPO >= 0) {
            this.props.listForBrandStatPartnerOffersAvail.UnSubscribe(this.SID_4BSUP);
        }
    };
    BrandAffilateEditor.prototype.doReSetRules = function () {
        this.setState({
            currency_rules: { isError: false },
            pprogram_rules: { isError: false },
            partner_rules: { isError: false },
            offer_rules: { isError: false }
        });
    };
    BrandAffilateEditor.prototype.isDataValid = function () {
        this.doReSetRules();
        if ((this.state.currency_id <= 0) || (this.state.currency_iso.length === 0)) {
            this.setState({ currency_rules: { isError: true, errorMessage: "Поле [валюта] не выбрано!" } });
            return false;
        }
        if ((this.state.pprogram_id <= 0) || (this.state.pprogram_title.length === 0)) {
            this.setState({ pprogram_rules: { isError: true, errorMessage: "Поле [аффилейт] не выбрано!" } });
            return false;
        }
        if ((this.state.partner_id <= 0) || (this.state.partner_login.length === 0)) {
            this.setState({ partner_rules: { isError: true, errorMessage: "Поле [партнер] не выбрано!" } });
            return false;
        }
        if ((this.state.offer_id <= 0) || (this.state.offer_title.length === 0)) {
            this.setState({ offer_rules: { isError: true, errorMessage: "Поле [оффер] не выбрано!" } });
            return false;
        }
        return true;
    };
    BrandAffilateEditor.prototype.OnUpdateDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.EditData({
                key: this.props.record.key,
                pprogram_id: this.state.pprogram_id,
                app_currency_id: this.state.currency_id,
                brand_id: this.props.rootRecord.key,
                usr_partner_id: this.state.partner_id,
                usr_partner_offer_id: this.state.offer_id
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Партнер для статистики изменен!");
            });
        }
    };
    BrandAffilateEditor.prototype.OnNewDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.AddData({
                pprogram_id: this.state.pprogram_id,
                app_currency_id: this.state.currency_id,
                brand_id: this.props.rootRecord.key,
                usr_partner_id: this.state.partner_id,
                usr_partner_offer_id: this.state.offer_id
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Партнер для статистики добавлен!");
            });
        }
    };
    BrandAffilateEditor.prototype.OnGoBackClick = function () {
        if (this.props.onGoBack) {
            this.props.onGoBack();
        }
    };
    BrandAffilateEditor.prototype.getFormTitle = function () {
        if (!this.props.record) {
            return "Добавить партнера для статистики";
        }
        else {
            return "Изменить партнера для статистики";
        }
    };
    BrandAffilateEditor.prototype.render = function () {
        var _this = this;
        return (React.createElement(CardEditorContainer_1.default, { onGoBackClick: this.OnGoBackClick.bind(this), title: this.getFormTitle(), state: this.props.state, maxHeight: 430 },
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Валюта :", placeholder: "Выберите валюту" }, value: { key: this.state.currency_id, value: this.state.currency_iso }, onValueChanged: function (newVal) {
                    _this.setState({
                        currency_id: newVal.key,
                        currency_iso: newVal.value,
                        currency_rules: { isError: false }
                    });
                }, items: this.props.availCurrency, required: true, rules: this.state.currency_rules }),
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "П.Программа :", placeholder: "Выберите партнерскую программу" }, value: { key: this.state.pprogram_id, value: this.state.pprogram_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        pprogram_id: newVal.key,
                        pprogram_title: newVal.value,
                        pprogram_rules: { isError: false },
                        partner_id: 0,
                        partner_login: "",
                        offer_id: 0,
                        offer_title: ""
                    }, function () {
                        _this.props.listForBrandStatPartnersAvail.LoadData(_this.state.pprogram_id);
                    });
                }, items: this.state.pprograms_avail, required: true, rules: this.state.pprogram_rules }),
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Партнер :", placeholder: "Выберите партнера" }, value: { key: this.state.partner_id, value: this.state.partner_login }, onValueChanged: function (newVal) {
                    _this.setState({
                        partner_id: newVal.key,
                        partner_login: newVal.value,
                        partner_rules: { isError: false },
                        offer_id: 0,
                        offer_title: ""
                    }, function () {
                        _this.props.listForBrandStatPartnerOffersAvail.LoadData(_this.state.partner_id);
                    });
                }, items: this.state.partners_avail, required: true, rules: this.state.partner_rules }),
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Оффер :", placeholder: "Выберите оффер" }, value: { key: this.state.offer_id, value: this.state.offer_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        offer_id: newVal.key,
                        offer_title: newVal.value,
                        offer_rules: { isError: false }
                    }, function () {
                        _this.props.listForBrandStatPartnerOffersAvail.LoadData(_this.state.partner_id);
                    });
                }, items: this.state.offers_avail, required: true, rules: this.state.offer_rules }),
            React.createElement(CardRowButtonSet_1.default, { editMode: this.props.record != null, title: { btnEdit: "Сохранить", btnNew: "Создать", btnGoBack: "Вернуться" }, onGoBackClick: this.OnGoBackClick.bind(this), onAddClick: this.OnNewDataClick.bind(this), onEditClick: this.OnUpdateDataClick.bind(this) })));
    };
    return BrandAffilateEditor;
}(React.Component));
exports.default = BrandAffilateEditor;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/main_brands_list/ui/component/options/affilate/BrandPartnerEditor.tsx
// module id = 1761
// module chunks = 0